import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';

interface BillingPortalResponse {
    url: string;
}

const createBillingPortal = async (sessionId: string | null): Promise<BillingPortalResponse> => {
    const { data } = await axios.post(`${API_URL}/subscription/manage`,
        {},
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
    return data;
};

export const useBillingPortal = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: () => createBillingPortal(sessionContext?.sessionId ?? null)
    });
}; 